import React from 'react'
import styles from './OverlayPicker.scss'
import Select from 'react-select'
import {tileServices} from 'lib/tileServices'

const optionsForSelect = Object.values(tileServices).map(
  service => ({label: service.name, value: service.id})
)

export class OverlayPicker extends React.PureComponent {
  render () {
    const {overlay, onPickOverlay} = this.props
    return (
      <div className={styles.OverlayPicker}>
        <Select
          clearable={false}
          searchable={false}
          value={overlay.id}
          onChange={(o) => onPickOverlay(tileServices[o.value])}
          options={optionsForSelect} />
      </div>
    )
  }
}
